'use client'

import { isStaleServerActionError } from '@/lib/next-server-action-errors'
import type { Key } from '@/root/shared-hooks/useGetTranslations/useGetTranslations'

const RELOAD_DELAY_MS = 1500

let reloadScheduled = false

export function resetStaleServerActionReloadStateForTests(): void {
  reloadScheduled = false
}

export function handleStaleServerAction(params: {
  error: unknown
  getTranslation: (key: Key) => string
  onError: (message: string, error?: unknown) => void
}): boolean {
  if (!isStaleServerActionError(params.error)) {
    return false
  }

  params.onError(params.getTranslation('editErrorStalePageReloading'), params.error)

  if (!reloadScheduled) {
    reloadScheduled = true
    window.setTimeout(() => {
      window.location.reload()
    }, RELOAD_DELAY_MS)
  }

  return true
}
